import { useEffect } from 'react';
import { useParticipants } from '@livekit/components-react';

const getParticipantRole = (participant) => {
  let metadata = {};
  try {
    metadata = JSON.parse(participant?.metadata || '{}');
  } catch {
    metadata = {};
  }
  const role = String(metadata.role || '').trim().toLowerCase();
  const identity = String(participant?.identity || '').toLowerCase();
  if (metadata.is_host || role === 'host' || identity.startsWith('host-')) return 'host';
  if (role === 'candidate' || identity.startsWith('candidate-')) return 'candidate';
  return role || 'guest';
};

/**
 * Reports whether a remote candidate is currently in the LiveKit room.
 */
export default function InterviewerCandidatePresenceWatcher({ onPresenceChange }) {
  const participants = useParticipants();

  useEffect(() => {
    const hasRemoteCandidate = participants.some((participant) => {
      if (participant.isLocal) return false;
      return getParticipantRole(participant) === 'candidate';
    });
    onPresenceChange?.(hasRemoteCandidate);
  }, [participants, onPresenceChange]);

  return null;
}
